import Box from "@mui/material/Box";
import CircularProgress, { CircularProgressProps } from "@mui/material/CircularProgress";
import { styled } from "@mui/material/styles";
import * as React from "react";

export type TimelimitCircularProgressProps = {
  /** 0 - 100 */
  value: number;
  color: "success" | "error";
};

const CircularProgressWrapper = styled(Box)`
  position: relative;
  width: 32px;
  height: 32px;
`;

const StyledCircularProgress = styled(CircularProgress)`
  position: absolute;
`;

const BackgroundCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.action.selected,
  position: "absolute",
}));

const TimelimitCircularProgress: React.FC<TimelimitCircularProgressProps> = props => {
  const circularProgressProps: CircularProgressProps = {
    variant: "determinate",
    color: props.color,
    value: props.value,
    size: 32,
    thickness: 6,
    sx: {
      scale: "-1 1",
    },
  };
  return (
    <CircularProgressWrapper>
      <StyledCircularProgress {...circularProgressProps} />
      <BackgroundCircularProgress
        variant="determinate"
        color={"info"}
        size={circularProgressProps.size}
        thickness={circularProgressProps.thickness}
        value={100}
      />
    </CircularProgressWrapper>
  );
};

TimelimitCircularProgress.displayName = "TimelimitCircularProgress";

export default TimelimitCircularProgress;
